<template>
  <div class="container-fluid" v-if="itemData.description">
    <h4 v-if="possibleItems.list.side == 'top'">
      {{ $t("Menu.list.stones.groups.outside").toUpperCase() }}
    </h4>
    <h4 v-if="possibleItems.list.side == 'left'">
      {{ $t("Menu.list.stones.groups.left").toUpperCase() }}
    </h4>
    <h4 v-if="possibleItems.list.side == 'right'">
      {{ $t("Menu.list.stones.groups.right").toUpperCase() }}
    </h4>
    <h4 v-if="possibleItems.list.side == 'inside'">
      {{ $t("Menu.list.stones.groups.inside").toUpperCase() }}
    </h4>
    <template
      v-if="itemData.description.stones.groups[groupId].libraryStone !== false"
    >
      <div class="row border-bottom">
        <div class="col-10 text-start menu-section">
          <h5>{{ $t("Menu.list.stones.group.libraryStone.title") }}</h5>
          <p>
            {{ itemData.description.stones.groups[groupId].libraryStone }}
          </p>
          <p class="text-danger">
            {{ $t("Menu.list.stones.group.libraryStone.info") }}
          </p>
        </div>
      </div>
    </template>
    <fieldset class="input-group" v-if="isStoneGroupWithMoreThanOneStone">
      <select
        class="form-control"
        @change="
          configure(
            'stones/group/' +
              possibleItems.groupId +
              '/' +
              ($event.target.value > 0 ? $event.target.value : 0)
          );
          setVarValueForStonePos($event.target.value, true);
        "
      >
        <option
          v-for="(stoneItem, stoneKey) in itemData.description.stones.groups[
            groupId
          ].stones"
          v-bind:key="'stone' + stoneKey"
          v-bind:value="stoneKey"
          :selected="parseInt(possibleItems.stoneId) === stoneKey"
        >
          {{ stoneItem.type }} {{ stoneItem.number }} x
          {{ $n(stoneItem.size, "carat") }} ct. -
          {{ stoneItem["qualityShort"] }}
        </option>
      </select>
    </fieldset>
    <template v-if="possibleItems.list.objects">
      <div class="row border-bottom">
        <div
          class="col-10 text-start menu-section"
          @click="toggleCurrentEdit('position')"
        >
          <h5>{{ $t("Menu.list.stones.group.object.title") }}</h5>
          <p v-if="currentEdit != 'position'">
            <template v-for="(item, index) in possibleItems.list.arrangements">
              <span v-if="item.match" v-bind:key="'arrangementText' + index">{{
                item.text
              }}</span>
            </template>
            <span> auf </span>
            <template v-for="(item, index) in possibleItems.list.objects">
              <span v-if="item.match" v-bind:key="'objectText' + index">{{
                item.text
              }}</span>
            </template>
            <template
              v-if="
                (pos.x != 0 || pos.y != 0) && varValueStonePos === 'group-pos_'
              "
            >
              <br />(x: {{ $n(pos.x) }} | y: {{ $n(pos.y) }})
            </template>
            <template v-else-if="stonePos.x != 0 || stonePos.y != 0">
              <br />(x: {{ $n(stonePos.x) }} | y: {{ $n(stonePos.y) }})
            </template>
          </p>
        </div>
        <div class="col-2 text-end">
          <img
            :src="appUrl + '/img/icons/edit.svg'"
            class="icon open"
            @click="toggleCurrentEdit('position')"
            v-if="currentEdit != 'position'"
          />
          <img
            :src="appUrl + '/img/icons/close.svg'"
            class="icon"
            :class="{
              first: !itemData.description.stones.groups[groupId].libraryStone,
            }"
            @click="toggleCurrentEdit('position')"
            v-else
          />
        </div>
        <div class="col-12" v-if="currentEdit == 'position'">
          <br />
          <div class="row">
            <div class="col-4">
              <fieldset
                v-if="isStoneGroupWithMoreThanOneStone"
                class="input-group text-start"
              >
                <label>{{
                  $t("Menu.list.stones.group.position.labelStoneSetting")
                }}</label>
              </fieldset>
              <fieldset
                v-if="varValueStonePos === 'group-pos_'"
                class="input-group text-start"
              >
                <label>{{
                  $t("Menu.list.stones.group.position.labelText1")
                }}</label>
              </fieldset>
              <fieldset
                v-if="varValueStonePos === 'group-pos_'"
                class="input-group text-start"
              >
                <label>{{
                  $t("Menu.list.stones.group.position.labelText2")
                }}</label>
              </fieldset>
            </div>
            <div class="col-8">
              <fieldset
                class="input-group"
                v-if="isStoneGroupWithMoreThanOneStone"
              >
                <select
                  class="form-control"
                  @change="
                    configure(
                      'stones/group/' +
                        possibleItems.groupId +
                        '/' +
                        ($event.target.value > 0 ? $event.target.value : 0)
                    );
                    setVarValueForStonePos($event.target.value, true);
                  "
                >
                  <option
                    value="-1"
                    :selected="varValueStonePos === 'group-pos_'"
                  >
                    {{ $t("Menu.list.stones.group.position.labelStoneGroup") }}
                  </option>
                  <template
                    v-for="(stoneItem, stoneKey) in itemData.description.stones
                      .groups[groupId].stones"
                  >
                    <option
                      v-if="parseInt(possibleItems.stoneId) === stoneKey"
                      v-bind:key="'stone' + stoneKey"
                      v-bind:value="stoneKey"
                      :selected="
                        parseInt(possibleItems.stoneId) === stoneKey &&
                        varValueStonePos === 'stone-pos_'
                      "
                    >
                      {{
                        $t(
                          "Menu.list.stones.group.position.labelCurrentStoneSetting"
                        )
                      }}
                    </option>
                  </template>
                </select>
              </fieldset>
              <fieldset
                v-if="varValueStonePos === 'group-pos_'"
                class="input-group"
              >
                <select
                  class="form-control"
                  @change="
                    changeItemByVarValue(
                      'arrangement_' +
                        possibleItems.groupId +
                        '_' +
                        $event.target.value
                    )
                  "
                >
                  <option
                    v-for="(item, index) in possibleItems.list.arrangements"
                    v-bind:key="'arrangement' + index"
                    v-bind:value="item.id"
                    :selected="item.match"
                  >
                    {{ item.text }}
                  </option>
                </select>
              </fieldset>
              <fieldset
                v-if="varValueStonePos === 'group-pos_'"
                class="input-group"
              >
                <select
                  class="form-control"
                  @change="
                    changeItemByVarValue(
                      'object_' +
                        possibleItems.groupId +
                        '_' +
                        $event.target.value
                    )
                  "
                >
                  <option
                    v-for="(item, index) in possibleItems.list.objects"
                    v-bind:key="'object' + index"
                    v-bind:value="item.id"
                    :selected="item.match"
                  >
                    {{ item.text }}
                  </option>
                </select>
              </fieldset>
            </div>
          </div>
          <div
            class="row form-inline"
            v-if="
              possibleItems.list.pos.x !== false &&
              possibleItems.list.pos.y !== false
            "
          >
            <div class="col-6 col-md-12 col-lg-6">
              <div class="input-group">
                <div class="input-group">
                  <div class="input-group-text input-position-x">X</div>
                  <input
                    v-if="varValueStonePos === 'group-pos_'"
                    type="number"
                    max="100"
                    min="-100"
                    step="0.1"
                    v-model="pos.x"
                    class="form-control"
                    @change="
                      changeItemByVarValue(
                        varValueStonePos +
                          possibleItems.groupId +
                          '_x_' +
                          parseFloat(pos.x)
                      )
                    "
                  />
                  <input
                    v-else
                    type="number"
                    max="100"
                    min="-100"
                    step="0.1"
                    v-model="stonePos.x"
                    class="form-control"
                    @change="
                      changeItemByVarValue(
                        varValueStonePos +
                          possibleItems.groupId +
                          '_' +
                          possibleItems.stoneId +
                          '_x_' +
                          parseFloat(stonePos.x)
                      )
                    "
                  />
                  <div class="input-group-text input-position-x">mm</div>
                </div>
                <span class="object-position-info">{{
                  $t("Menu.list.stones.group.object.lying.x")
                }}</span>
              </div>
            </div>
            <div class="col-6 col-md-12 col-lg-6">
              <div class="input-group">
                <div class="input-group">
                  <div class="input-group-text input-position-y">Y</div>
                  <input
                    v-if="varValueStonePos === 'group-pos_'"
                    type="number"
                    max="10"
                    min="-10"
                    step="0.1"
                    v-model="pos.y"
                    class="form-control"
                    @change="
                      changeItemByVarValue(
                        varValueStonePos +
                          possibleItems.groupId +
                          '_y_' +
                          parseFloat(pos.y)
                      )
                    "
                  />
                  <input
                    v-else
                    type="number"
                    max="10"
                    min="-10"
                    step="0.1"
                    v-model="stonePos.y"
                    class="form-control"
                    @change="
                      changeItemByVarValue(
                        varValueStonePos +
                          possibleItems.groupId +
                          '_' +
                          possibleItems.stoneId +
                          '_y_' +
                          parseFloat(stonePos.y)
                      )
                    "
                  />
                  <div class="input-group-text input-position-y">mm</div>
                </div>
                <span class="object-position-info">{{
                  $t("Menu.list.stones.group.object.lying.y")
                }}</span>
              </div>
            </div>
          </div>
          <br />
        </div>
        <div
          class="col-12"
          v-if="
            itemData.description.stones.groups[groupId].libraryStone === false
          "
        >
          <img
            v-if="possibleItems.list.side == 'top'"
            @click="showItemPlan"
            class="item-plan outside"
            :src="
              getApiHost +
              '/v2/images/plan/outside/false/' +
              possibleItems.groupId +
              '/' +
              possibleItems.stoneId +
              '/10/' +
              itemData.size +
              '/' +
              itemData.itemnumber +
              '.jpg'
            "
            alt=""
            width="100%"
          />
        </div>
      </div>
    </template>
    <template v-if="possibleItems.list.sizes">
      <div class="row border-bottom">
        <div
          class="col-10 text-start menu-section"
          @click="toggleCurrentEdit('size')"
        >
          <h5>{{ $t("Menu.list.stones.group.size.title") }}</h5>
          <p
            v-if="
              currentEdit != 'size' &&
              itemData.description.stones.groups[groupId].stones[stoneId]
            "
          >
            {{
              itemData.description.stones.groups[groupId].stones[stoneId]
                .number
            }}x
            {{
              $n(
                itemData.description.stones.groups[groupId].stones[stoneId]
                  .size,
                "carat"
              )
            }}
            ct. =
            {{
              $n(
                itemData.description.stones.groups[groupId].stones[stoneId]
                  .sizeTotal,
                "carat"
              )
            }}
            ct.<br />
            <template v-if="possibleItems.list.matrix">
              <template v-for="(item, index) in possibleItems.list.matrix">
                <span v-bind:key="'matrixItem' + index" v-if="item.match">{{
                  item.text
                }}</span>
              </template>
            </template>
            <template v-else>
              {{
                $t("Menu.list.stones.group.size.allocation." + allocation.type)
              }}
            </template>
          </p>
        </div>
        <div class="col-2 text-end">
          <img
            :src="appUrl + '/img/icons/edit.svg'"
            class="icon open"
            @click="toggleCurrentEdit('size')"
            v-if="currentEdit != 'size'"
          />
          <img
            :src="appUrl + '/img/icons/close.svg'"
            class="icon"
            @click="toggleCurrentEdit('size')"
            v-else
          />
        </div>
        <div class="col-12 text-start">
          <img
            v-if="
              possibleItems.list.side == 'top' && !possibleItems.list.objects
            "
            @click="showItemPlan"
            class="item-plan outside"
            :src="
              getApiHost +
              '/v2/images/plan/outside/false/' +
              possibleItems.groupId +
              '/' +
              possibleItems.stoneId +
              '/10/' +
              itemData.size +
              '/' +
              itemData.itemnumber +
              '.jpg'
            "
            alt=""
            width="100%"
          />
          <img
            v-if="possibleItems.list.side == 'left'"
            @click="showItemPlan"
            class="item-plan left"
            :src="
              getApiHost +
              '/Images/Item/Side/Left/' +
              itemData.size +
              '/' +
              itemData.itemnumber +
              '.jpg'
            "
            alt=""
            width="25%"
          />
          <img
            v-if="possibleItems.list.side == 'right'"
            @click="showItemPlan"
            class="item-plan right"
            :src="
              getApiHost +
              '/Images/Item/Side/Right/' +
              itemData.size +
              '/' +
              itemData.itemnumber +
              '.jpg'
            "
            alt=""
            width="25%"
          />
          <img
            v-if="possibleItems.list.side == 'inside'"
            @click="showItemPlan"
            class="item-plan inside"
            :src="
              getApiHost +
              '/v2/images/plan/inside/false/' +
              possibleItems.groupId +
              '/' +
              possibleItems.stoneId +
              '/10/' +
              itemData.size +
              '/' +
              itemData.itemnumber +
              '.jpg'
            "
            alt=""
            width="100%"
          />
        </div>
        <div
          class="col-12"
          v-if="currentEdit == 'size' && !possibleItems.list.exchangeStock"
        >
          <br />
          <div class="row">
            <div class="col-4 col-md-6 col-lg-4" style="padding-right: 0.1em">
              <div class="input-group">
                <div class="input-group">
                  <input
                    type="number"
                    max="255"
                    min="1"
                    step="1"
                    v-model="number"
                    class="form-control"
                    :readonly="
                      allocation.type >= 5 || possibleItems.list.matrix
                    "
                    @change="
                      changeItemByVarValue(
                        'number_' +
                          possibleItems.groupId +
                          '_' +
                          possibleItems.stoneId +
                          '_' +
                          number
                      )
                    "
                  />
                  <div class="input-group-text">x</div>
                </div>
              </div>
            </div>
            <div
              class="col-4 col-md-6 col-lg-4"
              style="padding-left: 0.1em; padding-right: 0.1em"
            >
              <select
                class="form-control"
                @change="
                  changeItemByVarValue(
                    'single-size_' +
                      possibleItems.groupId +
                      '_' +
                      possibleItems.stoneId +
                      '_' +
                      size
                  )
                "
                v-model="size"
              >
                <option
                  v-for="(item, index) in possibleItems.list.sizes"
                  v-bind:key="index"
                  :value="item.id"
                  :selected="item.match"
                >
                  {{ $n(item.text, "carat") }}
                </option>
              </select>
            </div>
            <div class="col-4 col-md-12 col-lg-4" id="inputTotalCarat">
              <div class="input-group">
                <div class="input-group">
                  <input
                    type="text"
                    readonly
                    class="form-control"
                    :value="$n(size * number, 'carat')"
                  />
                  <div class="input-group-text">ct.</div>
                </div>
              </div>
            </div>
            <div class="col-6" style="padding-right: 0.3em">
              <div class="input-group">
                <div class="input-group">
                  <select
                    class="form-control"
                    @change="
                      changeItemByVarValue(
                        'single-size_' +
                          possibleItems.groupId +
                          '_' +
                          possibleItems.stoneId +
                          '_' +
                          size
                      )
                    "
                    v-model="size"
                  >
                    <option
                      v-for="(item, index) in possibleItems.list.sizes"
                      v-bind:key="index"
                      :value="item.id"
                      :selected="item.match"
                    >
                      {{ $n(item.width, "mm") }} mm
                    </option>
                  </select>
                  <div class="input-group-text">B:</div>
                </div>
              </div>
            </div>
            <div class="col-6" style="padding-right: 0.3em">
              <div class="input-group">
                <div class="input-group">
                  <select
                    class="form-control"
                    @change="
                      changeItemByVarValue(
                        'single-size_' +
                          possibleItems.groupId +
                          '_' +
                          possibleItems.stoneId +
                          '_' +
                          size
                      )
                    "
                    v-model="size"
                  >
                    <option
                      v-for="(item, index) in possibleItems.list.sizes"
                      v-bind:key="index"
                      :value="item.id"
                      :selected="item.match"
                    >
                      {{ $n(item.length, "mm") }} mm
                    </option>
                  </select>
                  <div class="input-group-text">L:</div>
                </div>
              </div>
            </div>
          </div>
          <div class="row" v-if="possibleItems.list.allocations">
            <div
              :class="{
                'col-7': allocation.type == 0,
                'col-12': allocation.type != 0,
              }"
              style="padding-right: 0.1em"
            >
              <select
                class="form-control"
                v-model="allocation.type"
                @change="
                  changeItemByVarValue(
                    'allocation_' +
                      possibleItems.groupId +
                      '_' +
                      possibleItems.stoneId +
                      '_' +
                      allocation.type
                  )
                "
              >
                <optgroup
                  :label="
                    $t('Menu.list.stones.group.size.allocation.group.labels.1')
                  "
                >
                  <option value="0">
                    {{ $t("Menu.list.stones.group.size.allocation.0") }}
                  </option>
                </optgroup>
                <optgroup
                  :label="
                    $t('Menu.list.stones.group.size.allocation.group.labels.2')
                  "
                >
                  <option value="1">
                    {{ $t("Menu.list.stones.group.size.allocation.1") }}
                  </option>
                  <option value="-2">
                    {{ $t("Menu.list.stones.group.size.allocation.-2") }}
                  </option>
                  <option value="-3">
                    {{ $t("Menu.list.stones.group.size.allocation.-3") }}
                  </option>
                  <option value="-4">
                    {{ $t("Menu.list.stones.group.size.allocation.-4") }}
                  </option>
                </optgroup>
                <optgroup
                  :label="
                    $t('Menu.list.stones.group.size.allocation.group.labels.3')
                  "
                >
                  <option value="2">
                    {{ $t("Menu.list.stones.group.size.allocation.2") }}
                  </option>
                  <option value="3">
                    {{ $t("Menu.list.stones.group.size.allocation.3") }}
                  </option>
                </optgroup>
                <optgroup
                  :label="
                    $t('Menu.list.stones.group.size.allocation.group.labels.4')
                  "
                >
                  <option value="5">
                    {{ $t("Menu.list.stones.group.size.allocation.5") }}
                  </option>
                  <option value="6">
                    {{ $t("Menu.list.stones.group.size.allocation.6") }}
                  </option>
                </optgroup>
              </select>
            </div>
            <div
              class="col-5"
              v-if="allocation.type == 0"
              style="padding-left: 0.1em; padding-right: 0.3em"
            >
              <div class="input-group">
                <div class="input-group">
                  <input
                    type="number"
                    max="50"
                    min="0"
                    step="0.1"
                    v-model="allocation.distance"
                    class="form-control"
                    @change="
                      changeItemByVarValue(
                        'distance-abs_' +
                          possibleItems.groupId +
                          '_' +
                          possibleItems.stoneId +
                          '_' +
                          allocation.distance
                      )
                    "
                  />
                  <div class="input-group-text">mm</div>
                </div>
              </div>
            </div>
          </div>
          <div class="row" v-if="possibleItems.list.matrix">
            <div class="col-12">
              <select
                class="form-control"
                @change="
                  changeItemByVarValue(
                    'matrix-id_' +
                      possibleItems.groupId +
                      '_' +
                      possibleItems.stoneId +
                      '_' +
                      $event.target.value
                  )
                "
              >
                <option
                  v-for="(item, index) in possibleItems.list.matrix"
                  v-bind:key="'matrix' + index"
                  v-bind:value="item.id_number"
                  :selected="item.match"
                >
                  {{ item.text }}
                </option>
              </select>
            </div>
          </div>
        </div>
        <div
          class="col-12 text-start"
          v-if="currentEdit == 'size' && possibleItems.list.exchangeStock"
        >
          {{ possibleItems.list.exchangeStock.description }}<br />
          <br />
          <div class="text-center">
            <button
              class="btn btn-secondary btn-block btn-remove-diamond"
              :class="{
                'lab-grown': possibleItems.list.exchangeStock.stoneType === '5',
              }"
              @click="
                changeItemByVarValue(
                  'remove-pool_' + possibleItems.list.exchangeStock.pool_id
                )
              "
            >
              {{ $t("Menu.list.stones.group.diamondExchange.remove") }}
            </button>
          </div>
        </div>
      </div>
    </template>
    <Form
      v-if="possibleItems.list.forms"
      :possibleItems="possibleItems"
      :currentEdit="currentEdit"
      :itemData="itemData"
      :stoneId="stoneId"
      :groupId="groupId"
    />
    <Setting
      v-if="possibleItems.list.forms"
      :possibleItems="possibleItems"
      :currentEdit="currentEdit"
      :itemData="itemData"
      :stoneId="stoneId"
      :groupId="groupId"
    />
    <Clamping
      v-if="possibleItems.list.forms"
      :possibleItems="possibleItems"
      :currentEdit="currentEdit"
      :itemData="itemData"
      :stoneId="stoneId"
      :groupId="groupId"
      :clamping="clamping"
    />
    <Tower
      v-if="possibleItems.list.forms"
      :possibleItems="possibleItems"
      :currentEdit="currentEdit"
      :itemData="itemData"
      :stoneId="stoneId"
      :groupId="groupId"
      :clamping="clamping"
    />
    <template
      v-if="
        possibleItems.list.waves &&
        possibleItems.list.number &&
        possibleItems.list.number[0] > 1
      "
    >
      <div class="row border-bottom">
        <div
          class="col-10 text-start menu-section"
          @click="toggleCurrentEdit('waves')"
        >
          <h5>{{ $t("Menu.list.stones.group.waves.title") }}</h5>
          <p v-if="currentEdit != 'waves'">
            <span v-if="possibleItems.list.waves[0].lineAngle != 0"
              >{{ $t("Menu.list.stones.group.waves.sinus.lineAngle.text1") }}
              {{ $n(possibleItems.list.waves[0].lineAngle) }}
              {{
                $t("Menu.list.stones.group.waves.sinus.lineAngle.text2")
              }}.</span
            >
            <span v-else-if="possibleItems.list.waves[0].sinus.waves != 0"
              >{{ $t("Menu.list.stones.group.waves.sinus.wave.text1") }}
              {{
                $tc(
                  "Menu.list.stones.group.waves.sinus.waves",
                  possibleItems.list.waves[0].sinus.waves
                )
              }}</span
            >
            <span v-else>{{
              $t("Menu.list.stones.group.waves.sinus.wave.text2")
            }}</span>
          </p>
        </div>
        <div class="col-2 text-end">
          <img
            :src="appUrl + '/img/icons/edit.svg'"
            class="icon open"
            @click="toggleCurrentEdit('waves')"
            v-if="currentEdit != 'waves'"
          />
          <img
            :src="appUrl + '/img/icons/close.svg'"
            class="icon"
            @click="toggleCurrentEdit('waves')"
            v-else
          />
        </div>
        <template v-if="currentEdit == 'waves'">
          <div class="col-6 text-center">
            <br />
            <select class="form-control" v-model="waves.type">
              <option value="angle">
                {{ $t("Menu.list.stones.group.waves.sinus.options.option1") }}
              </option>
              <option value="sinus">
                {{ $t("Menu.list.stones.group.waves.sinus.options.option2") }}
              </option>
            </select>
          </div>
          <div class="col-6">
            <br />
            <div class="input-group" v-if="waves.type == 'angle'">
              <div class="input-group">
                <input
                  type="number"
                  max="180"
                  min="1"
                  step="1"
                  v-model="waves.lineAngle"
                  class="form-control"
                  @change="
                    changeItemByVarValue(
                      'line-angle_' +
                        possibleItems.groupId +
                        '_' +
                        possibleItems.stoneId +
                        '_' +
                        $event.target.value
                    )
                  "
                />
                <div class="input-group-text">&deg;</div>
              </div>
            </div>
            <div class="input-group" v-if="waves.type == 'sinus'">
              <div class="input-group">
                <input
                  type="number"
                  max="5"
                  min="-5"
                  step="1"
                  v-model="waves.sinus.waves"
                  class="form-control"
                  @change="
                    changeItemByVarValue(
                      'sinus-wave_' +
                        possibleItems.groupId +
                        '_' +
                        possibleItems.stoneId +
                        '_' +
                        $event.target.value
                    )
                  "
                />
                <div class="input-group-text">
                  {{ $t("Menu.list.stones.group.waves.sinus.wave.groupAddon") }}
                </div>
              </div>
            </div>
          </div>
          <div class="col-6 text-start" v-if="waves.type == 'sinus'">
            <label>{{
              $t("Menu.list.stones.group.waves.sinus.wave.labelText1")
            }}</label>
          </div>
          <div class="col-6" v-if="waves.type == 'sinus'">
            <div class="input-group">
              <input
                type="number"
                max="5"
                min="-5"
                step="1"
                v-model="waves.sinus.distance"
                class="form-control"
                @change="
                  changeItemByVarValue(
                    'sinus-distance_' +
                      possibleItems.groupId +
                      '_' +
                      possibleItems.stoneId +
                      '_' +
                      $event.target.value
                  )
                "
              />
              <div class="input-group-text">mm</div>
            </div>
          </div>
        </template>
      </div>
    </template>
    <template v-if="possibleItems.list.packages">
      <div class="row border-bottom">
        <div
          class="col-10 text-start menu-section"
          @click="toggleCurrentEdit('packages')"
        >
          <h5>{{ $t("Menu.list.stones.group.packages.title") }}</h5>
          <p v-if="currentEdit != 'packages'">
            {{
              $tc(
                "Menu.list.stones.group.packages.numberOfStones",
                possibleItems.list.packages[0].number,
                { distance: possibleItems.list.packages[0].distance }
              )
            }}
          </p>
        </div>
        <div class="col-2 text-end">
          <img
            :src="appUrl + '/img/icons/edit.svg'"
            class="icon open"
            @click="toggleCurrentEdit('packages')"
            v-if="currentEdit != 'packages'"
          />
          <img
            :src="appUrl + '/img/icons/close.svg'"
            class="icon"
            @click="toggleCurrentEdit('packages')"
            v-else
          />
        </div>
        <template v-if="currentEdit == 'packages'">
          <div class="col-12">
            <br />
            <fieldset class="input-group">
              <div class="input-group">
                <input
                  type="number"
                  max="5"
                  min="-5"
                  step="1"
                  v-model="packages.number"
                  class="form-control"
                  @change="
                    changeItemByVarValue(
                      'group-number_' +
                        possibleItems.groupId +
                        '_' +
                        possibleItems.stoneId +
                        '_' +
                        $event.target.value
                    )
                  "
                />
                <div class="input-group-text">
                  {{ $t("Menu.list.stones.group.packages.groupAddon.text1") }}
                </div>
              </div>
            </fieldset>
          </div>
          <div class="col-12" v-if="packages.number > 1">
            <fieldset class="input-group">
              <div class="input-group">
                <div class="input-group-text">
                  {{ $t("Menu.list.stones.group.packages.groupAddon.text2") }}
                </div>
                <input
                  type="number"
                  max="20"
                  min="0"
                  step="0.1"
                  v-model="packages.distance"
                  class="form-control"
                  @change="
                    changeItemByVarValue(
                      'group-distance_' +
                        possibleItems.groupId +
                        '_' +
                        possibleItems.stoneId +
                        '_' +
                        $event.target.value
                    )
                  "
                />
                <div class="input-group-text">
                  {{ $t("Menu.list.stones.group.packages.groupAddon.text3") }}
                </div>
              </div>
            </fieldset>
          </div>
        </template>
      </div>
    </template>
    <template
      v-if="
        possibleItems.list.qualities && possibleItems.list.qualities.length > 0
      "
    >
      <div class="row border-bottom">
        <div class="col-12 text-start">
          <h5 class="headline-stone-quality">
            {{
              possibleItems.list.qualityName ||
              $t("Menu.list.stones.group.quality.quality")
            }}
          </h5>
          <div
            class="premium-selection"
            v-if="
              itemData.description.stones.groups[groupId].size /
                itemData.description.stones.groups[groupId].number.replace(
                  /\D/g,
                  ''
                ) >=
                0.3 && possibleItems.list.qualities[0].priceType !== ''
            "
          >
            <h6>
              {{
                $t(
                  "Menu.list.stones.qualitySpot." +
                    possibleItems.list.qualities[0].priceType +
                    ".title"
                )
              }}
            </h6>
            <ul>
              <li
                v-if="
                  $t(
                    'Menu.list.stones.qualitySpot.' +
                      possibleItems.list.qualities[0].priceType +
                      '.point1'
                  )
                "
              >
                {{
                  $t(
                    "Menu.list.stones.qualitySpot." +
                      possibleItems.list.qualities[0].priceType +
                      ".point1"
                  )
                }}
              </li>
              <li
                v-if="
                  $t(
                    'Menu.list.stones.qualitySpot.' +
                      possibleItems.list.qualities[0].priceType +
                      '.point2'
                  )
                "
              >
                {{
                  $t(
                    "Menu.list.stones.qualitySpot." +
                      possibleItems.list.qualities[0].priceType +
                      ".point2"
                  )
                }}
              </li>
              <li
                v-if="
                  $t(
                    'Menu.list.stones.qualitySpot.' +
                      possibleItems.list.qualities[0].priceType +
                      '.point3'
                  )
                "
              >
                {{
                  $t(
                    "Menu.list.stones.qualitySpot." +
                      possibleItems.list.qualities[0].priceType +
                      ".point3"
                  )
                }}
              </li>
            </ul>
          </div>
          <div
            class="premium-selection lab-grown"
            v-if="
              currentItem.description &&
              isDiamondExchange(true) &&
              (currentItem.description.stones.groups[groupId].stones[0]
                .qualityId === 92 ||
                currentItem.description.stones.groups[groupId].stones[0]
                  .qualityId === 93)
            "
          >
            <h6>{{ $t("Menu.list.stones.qualitySpot.labGrown.title") }}</h6>
            <ul>
              <li v-if="$t('Menu.list.stones.qualitySpot.labGrown.point1')">
                {{ $t("Menu.list.stones.qualitySpot.labGrown.point1") }}
              </li>
              <li v-if="$t('Menu.list.stones.qualitySpot.labGrown.point2')">
                {{ $t("Menu.list.stones.qualitySpot.labGrown.point2") }}
              </li>
              <li v-if="$t('Menu.list.stones.qualitySpot.labGrown.point3')">
                {{ $t("Menu.list.stones.qualitySpot.labGrown.point3") }}
              </li>
            </ul>
          </div>
          <div
            class="row quality-line"
            v-for="item in possibleItems.list.qualities"
            v-bind:key="item.id"
            :class="{ on: item.match }"
            @click="
              changeItemByVarValue(
                item.cmd
                  ? item.cmd
                  : 'quality_' +
                      possibleItems.groupId +
                      '_' +
                      possibleItems.stoneId +
                      '_' +
                      item.id
              )
            "
          >
            <div class="col-8 col-md-7 col-lg-8" v-if="item.text_short">
              <template
                v-if="
                  possibleItems.list.qualities[0].priceType &&
                  possibleItems.list.qualities[0].priceType !== '' &&
                  item.id != 11
                "
              >
                {{
                  $t(
                    "Menu.list.stones.qualitySpot.qualityShort." + item.id + ""
                  )
                }}
                - {{ item.text }}
              </template>
              <template v-else>
                {{ item.text_short }} - {{ item.text }}
              </template>
            </div>
            <div class="col-8 col-md-7 col-lg-8" v-else>
              {{ item.text }}
            </div>
            <div
              class="col-4 col-md-5 col-lg-4 text-end"
              :class="{ highlight: item.highlight === true }"
            >
              {{
                $n(
                  getPrice(
                    isDiamondExchange(false) ? item.priceStone : item.price
                  ),
                  "currency"
                )
              }}
              <i
                v-if="item.highlight === true"
                class="fa fa-star icon-star"
                aria-hidden="true"
              ></i>
            </div>
          </div>
        </div>
      </div>
      <div
        class="row border-bottom"
        v-if="
          possibleItems.list.pools &&
          Object.keys(possibleItems.list.pools).length > 1
        "
      >
        <div class="col-12 text-start">
          <h5>{{ $t("Menu.list.stones.group.quality.color") }}</h5>
          <fieldset class="input-group change-pool">
            <select
              class="form-control"
              @change="
                changeItemByVarValue(
                  'change-pool_' +
                    possibleItems.groupId +
                    '_' +
                    possibleItems.stoneId +
                    '_' +
                    $event.target.value
                )
              "
            >
              <option
                v-for="(item, index) in possibleItems.list.pools"
                v-bind:key="index"
                :value="item.pool_id"
                :selected="item.match"
              >
                {{ item.text }}
              </option>
            </select>
          </fieldset>
        </div>
      </div>
    </template>
    <template v-if="possibleItems.list.addons">
      <div class="row border-bottom">
        <div
          class="col-10 text-start menu-section"
          @click="toggleCurrentEdit('addons')"
        >
          <h5>{{ $t("Menu.list.stones.group.addon.title") }}</h5>
          <p
            v-if="
              currentEdit != 'addons' &&
              possibleItems.list.addons.current.length === 0
            "
          >
            {{ $t("Menu.list.stones.group.addon.empty") }}
          </p>
        </div>
        <div class="col-2 text-end">
          <img
            :src="appUrl + '/img/icons/edit.svg'"
            class="icon open"
            @click="toggleCurrentEdit('addons')"
            v-if="currentEdit != 'addons'"
          />
          <img
            :src="appUrl + '/img/icons/close.svg'"
            class="icon"
            @click="toggleCurrentEdit('addons')"
            v-if="currentEdit == 'addons'"
          />
        </div>
        <div class="col-12">
          <ul
            class="default-option-list addon-list"
            v-if="possibleItems.list.addons.current.length > 0"
          >
            <li
              v-for="(addon, index) in possibleItems.list.addons.current"
              v-bind:key="'addon_current_' + index"
              class="pointer match"
            >
              <img
                @click="openPicture(imageHost + '/' + addon.picture)"
                :src="imageHost + '/' + addon.picture"
                :alt="addon.text"
                class="thumb"
              />
              <p>{{ addon.text }}</p>
              <a
                @click="
                  changeItemByVarValue(
                    '21_' +
                      possibleItems.groupId +
                      '_' +
                      possibleItems.stoneId +
                      '_' +
                      index
                  )
                "
                type="button"
                class="close"
                aria-label="Close"
              >
                <img
                  :src="appUrl + '/img/icons/close.svg'"
                  class="icon"
                  alt="close"
                />
              </a>
            </li>
          </ul>
          <ul
            class="default-option-list addon-list"
            v-if="currentEdit == 'addons'"
          >
            <li
              v-for="(addon, index) in possibleItems.list.addons.possible"
              v-bind:key="'addon_item_' + index"
              class="pointer"
              @click="
                changeItemByVarValue(
                  '20_' +
                    possibleItems.groupId +
                    '_' +
                    possibleItems.stoneId +
                    '_' +
                    addon.addon_id
                )
              "
            >
              <img
                :src="imageHost + '/' + addon.picture"
                :alt="addon.text"
                class="thumb"
              />
              <p>{{ addon.text }}</p>
            </li>
          </ul>
        </div>
      </div>
    </template>
    <template v-if="possibleItems.list.mirror">
      <div class="row border-bottom">
        <div
          class="col-10 text-start menu-section"
          @click="toggleCurrentEdit('mirror')"
        >
          <h5>{{ $t("Menu.list.stones.group.mirror.title") }}</h5>
          <p v-if="currentEdit != 'mirror'">
            <span
              v-if="
                possibleItems.list.mirror[0].x == 0 &&
                possibleItems.list.mirror[0].y == ''
              "
            >
              {{ $t("Menu.list.stones.group.mirror.descriptions.text1") }}
            </span>
            <span
              v-else-if="
                possibleItems.list.mirror[0].x != 0 &&
                possibleItems.list.mirror[0].y == ''
              "
            >
              {{ $t("Menu.list.stones.group.mirror.descriptions.text2") }}
            </span>
            <span
              v-else-if="
                possibleItems.list.mirror[0].x == 0 &&
                possibleItems.list.mirror[0].y != ''
              "
            >
              {{ $t("Menu.list.stones.group.mirror.descriptions.text3") }}
            </span>
            <span v-else>
              {{ $t("Menu.list.stones.group.mirror.descriptions.text4") }}
            </span>
          </p>
        </div>
        <div class="col-2 text-end">
          <img
            :src="appUrl + '/img/icons/edit.svg'"
            class="icon open"
            @click="toggleCurrentEdit('mirror')"
            v-if="currentEdit != 'mirror'"
          />
          <img
            :src="appUrl + '/img/icons/close.svg'"
            class="icon"
            @click="toggleCurrentEdit('mirror')"
            v-else
          />
        </div>
        <div class="col-12" v-if="currentEdit == 'mirror'">
          <br />
          <h5>{{ $t("Menu.list.stones.group.mirror.vertical.title") }}</h5>
          <select
            @change="
              changeItemByVarValue(
                'mirror-x_' +
                  possibleItems.groupId +
                  '_' +
                  possibleItems.stoneId +
                  '_' +
                  $event.target.value
              )
            "
            class="form-control mirror-stone"
          >
            <option value="0" :selected="possibleItems.list.mirror[0].x == 0">
              {{ $t("Menu.list.stones.group.mirror.options.option1") }}
            </option>
            <option value="1" :selected="possibleItems.list.mirror[0].x == 1">
              {{ $t("Menu.list.stones.group.mirror.options.option2") }}
            </option>
          </select>
          <br />
          <p class="text-start">
            {{ $t("Menu.list.stones.group.mirror.vertical.explaination") }}
          </p>
        </div>
        <div class="col-12" v-if="currentEdit == 'mirror'">
          <h5>{{ $t("Menu.list.stones.group.mirror.horizontal.title") }}</h5>
          <select
            @change="
              changeItemByVarValue(
                'mirror-y-object_' +
                  possibleItems.groupId +
                  '_' +
                  possibleItems.stoneId +
                  '_' +
                  $event.target.value
              )
            "
            class="form-control mirror-stone"
          >
            <option value="">
              {{ $t("Menu.list.stones.group.mirror.options.option1") }}
            </option>
            <option
              v-for="(item, index) in possibleItems.list.objects"
              v-bind:key="'object' + index"
              v-bind:value="item.id"
              :selected="item.id == possibleItems.list.mirror[0].y"
            >
              {{ item.text }}
            </option>
          </select>
          <br />
          <p class="text-start">
            {{ $t("Menu.list.stones.group.mirror.horizontal.explaination") }}
          </p>
        </div>
      </div>
    </template>
    <template v-if="possibleItems.list && menuList['stones/diamondExchange']">
      <div class="row border-bottom">
        <div
          class="col-10 text-start menu-section"
          @click="configure('stones/diamondExchange')"
        >
          <h5>{{ $t("Menu.list.stones.group.diamondExchange.title") }}</h5>
          <p v-if="possibleItems.list.exchangeStock">
            {{ possibleItems.list.exchangeStock.description }}
          </p>
          <p v-else>
            {{ $t("Menu.list.stones.group.diamondExchange.noStone") }}
          </p>
        </div>
        <div class="col-2 text-end">
          <img
            :src="appUrl + '/img/icons/edit.svg'"
            class="icon open"
            @click="configure('stones/diamondExchange')"
          />
        </div>
      </div>
    </template>
    <div class="row">
      <div class="col-12">
        <template v-if="possibleItems.list.settingsOnTop > 1">
          <p class="text-danger">
            {{ $t("Menu.list.stones.group.action.note") }}
          </p>
          <a
            class="btn btn-secondary"
            @click="
              changeItemByVarValue(
                'drop-stone_' +
                  possibleItems.groupId +
                  '_' +
                  possibleItems.stoneId
              )
            "
          >
            {{ $t("Menu.list.stones.group.action.button2") }}
          </a>
        </template>
        <a
          v-else
          class="btn btn-secondary"
          @click="changeItemByVarValue('drop-group_' + possibleItems.groupId)"
        >
          {{ $t("Menu.list.stones.group.action.button1") }}
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import Config from "@/vuex/Config";
import SetData from "@/vuex/SetData";
import MenuList from "@/assets/Helper/MenuList";
import Setting from "./Default/Setting";
import Form from "./Default/Form";
import Clamping from "./Default/Clamping";
import Tower from "./Default/Tower";

export default {
  name: "VariationsStonesGroup",
  components: {
    Setting,
    Form,
    Clamping,
    Tower,
  },
  props: ["possibleItems", "currentItem"],
  data() {
    return {
      itemData: {},
      appUrl: Config.getters.getAppUrl,
      imageHost: process.env.VUE_APP_IMAGE_HOST,
      getApiHost: Config.getters.getApiHost,
      currentEdit: "",
      groupId: 0,
      stoneId: 0,
      varValueStonePos: "group-pos_",
      forceGroupForStonePos: false,
      size: 0,
      number: 0,
      allocation: {
        type: 1,
        distance: 0,
      },
      clamping: {
        top_distance: 0,
        top_factor: true,
        down_distance: 0,
        down_factor: true,
        depth: -1,
        ring_type: -1,
        width: 0,
      },
      waves: {
        type: "angle",
        lineAngle: 0,
        sinus: {
          waves: 0,
          distance: 0,
        },
      },
      packages: {
        number: 1,
        distance: 0,
      },
      pos: {
        x: 0,
        y: 0,
      },
      stonePos: {
        x: 0,
        y: 0,
      },
      currentSelection: {
        side: null,
        pool: null,
        typeId: null,
        size: null,
        number: null,
        allocation: null,
        allocationLast: null,
        qualityId: null,
        object: null,
        arrangement: null,
        libraryStoneId: null,
        distanceAbs: 0,
        matrixId: null,
        posX: null,
        posY: null,
        stonePosX: null,
        stonePosY: null,
        lastAction: "",
        lastVarValueStonePos: "",
      },
    };
  },
  updated() {
    this.setItem();

    if (this.possibleItems.groupId) {
      this.groupId = parseInt(this.possibleItems.groupId);
      this.stoneId = parseInt(this.possibleItems.stoneId);

      if (this.isStoneGroupWithMoreThanOneStone) {
        if (!this.forceGroupForStonePos) {
          this.setVarValueForStonePos(this.stoneId, false);
        }
      } else {
        this.setVarValueForStonePos(-1, false);
      }
      this.getCurrentStoneGroup();
    }
  },
  mounted() {
    this.setItem();
  },
  methods: {
    isDiamondExchange: function (checkCurrentGroup) {
      let stoneGroup = parseInt(
        this.$parent.$parent.$parent["getGroupForDiamondExchange"]()
      );
      if (checkCurrentGroup) {
        return stoneGroup > -1 && stoneGroup === this.groupId;
      }
      return stoneGroup > -1;
    },
    setVarValueForStonePos: function (stoneId, clearCurrentSelection) {
      if (parseInt(stoneId) === -1) {
        this.forceGroupForStonePos = true;
        this.varValueStonePos = "group-pos_";
      } else {
        this.forceGroupForStonePos = false;
        this.varValueStonePos = "stone-pos_";
      }
      if (clearCurrentSelection === true) {
        this.clearCurrentSelection();
      }
    },
    getPrice: function (price) {
      if (isNaN(price) && typeof price == "string") {
        return price
          .toString()
          .substr(0, price.length - 2)
          .replace(",", "");
      } else {
        return price;
      }
    },
    setItem: function () {
      if (typeof this.currentItem === "string") {
        let set = SetData.getters.getSet;
        this.itemData = set.items[0];
      } else {
        this.itemData = this.currentItem;
      }
    },
    changeItemByVarValue: function (varValue) {
      this.setCurrentSelection();

      if (
        varValue.substr(0, 11) == "drop-group_" ||
        varValue.substr(0, 11) == "drop-stone_"
      ) {
        if (!confirm(this.$t("Notifications.askBeforeAction"))) {
          return false;
        }
        this.$parent.$parent.$data.currentVarType = "stones";
      } else {
        this.$parent.$parent.$data.currentVarType =
          "stones/group/" +
          this.possibleItems.groupId +
          "/" +
          this.possibleItems.stoneId;
      }

      this.changeCurrentSelection(varValue);

      this.$parent.$parent.changeItemByVarValue(varValue);
    },
    toggleCurrentEdit: function (id) {
      if (
        id === "size" &&
        this.possibleItems.list.sizes &&
        this.possibleItems.list.sizes.length < 1
      ) {
        return;
      }
      this.currentEdit = this.currentEdit == id ? "" : id;
    },
    configure: function (type) {
      this.$root.$emit("configure", type);
    },
    openPicture: function (imgSrc) {
      this.$parent.$parent.$parent.$parent.openPicture(imgSrc);
    },
    showItemPlan: function (imgSrc) {
      this.$root.$emit("showPicture", imgSrc);
    },
    setCurrentSelection: function () {
      if (this.itemData.description.stones.groups[this.groupId]) {
        let groupData = this.itemData.description.stones.groups[this.groupId];
        let stoneData = groupData;

        if (groupData.libraryStoneId > 0) {
          // do nothing
        } else {
          stoneData =
            this.itemData.description.stones.groups[this.groupId].stones[
              this.stoneId
            ];
        }

        this.currentSelection.side = groupData.side;
        this.currentSelection.pool =
          stoneData && stoneData.pool ? stoneData.pool : 0;
        this.currentSelection.typeId =
          stoneData && stoneData.typeId ? stoneData.typeId : "";
        this.currentSelection.size = stoneData.sizeTotal
          ? stoneData.sizeTotal
          : stoneData.size;
        this.currentSelection.number = parseInt(stoneData.number);
        this.currentSelection.allocation =
          stoneData && stoneData.allocation ? stoneData.allocation : 0;
        this.currentSelection.qualityId = stoneData.qualityId;
        this.currentSelection.object = groupData.object;
        this.currentSelection.arrangement = groupData.arrangement;
        this.currentSelection.libraryStoneId =
          groupData.libraryStoneId > 0 ? groupData.libraryStoneId : 0;
        this.currentSelection.matrixId =
          stoneData && stoneData.matrixId > 0 ? stoneData.matrixId : 0;
        this.currentSelection.posX = groupData.posX;
        this.currentSelection.posY = groupData.posY;
        this.currentSelection.stonePosX = stoneData.posX;
        this.currentSelection.stonePosY = stoneData.posY;
        this.currentSelection.distanceAbs =
          stoneData.distance && stoneData.distance.abs
            ? parseFloat(stoneData.distance.abs)
            : 0;
      }
    },
    clearCurrentSelection: function () {
      this.currentSelection = {
        groupId: null,
        side: null,
        pool: null,
        typeId: null,
        size: null,
        number: null,
        allocation: null,
        allocationLast: null,
        qualityId: null,
        object: null,
        arrangement: null,
        libraryStoneId: null,
        matrixId: null,
        posX: null,
        posY: null,
        stonePosX: null,
        stonePosY: null,
        lastAction: "",
        lastVarValueStonePos: "",
      };
    },
    changeCurrentSelection: function (varValue) {
      let splitValue = varValue.split("_");

      this.currentSelection.lastAction = varValue;
      this.currentSelection.lastVarValueStonePos = this.varValueStonePos;
      this.currentSelection.allocationLast = null;

      if (varValue.indexOf("single-size") >= 0) {
        this.currentSelection.size =
          parseFloat(splitValue[splitValue.length - 1]) *
          this.currentSelection.number;
      } else if (varValue.indexOf("number_") >= 0) {
        let singleSize = parseFloat(
          ((this.currentSelection.size / this.currentSelection.number) * 1000) /
            1000
        ).toFixed(3);
        this.currentSelection.number = parseInt(
          splitValue[splitValue.length - 1]
        );
        this.currentSelection.size = parseFloat(
          (parseFloat(singleSize) * this.currentSelection.number).toFixed(3)
        );
      } else if (varValue.indexOf("type_") >= 0) {
        this.currentSelection.typeId = splitValue[splitValue.length - 1];
      } else if (varValue.indexOf("allocation_") >= 0) {
        this.currentSelection.allocationLast = this.currentSelection.allocation;
        this.currentSelection.allocation = splitValue[splitValue.length - 1];
      } else if (varValue.indexOf("quality_") >= 0) {
        this.currentSelection.qualityId = splitValue[splitValue.length - 1];
      } else if (varValue.indexOf("distance-abs_") >= 0) {
        this.currentSelection.distanceAbs = parseFloat(
          splitValue[splitValue.length - 1]
        );
      } else if (varValue.indexOf("pool_") >= 0) {
        this.currentSelection.pool = splitValue[splitValue.length - 1];
      } else if (varValue.indexOf("arrangement_") >= 0) {
        this.currentSelection.arrangement = splitValue[splitValue.length - 1];
      } else if (
        varValue.indexOf("object_") >= 0 &&
        varValue.indexOf("mirror-") < 0
      ) {
        this.currentSelection.object = splitValue[splitValue.length - 1];
      } else if (varValue.indexOf("matrix-id_") >= 0) {
        this.currentSelection.matrixId =
          splitValue[splitValue.length - 1].split(":")[0];
      } else if (
        varValue.indexOf("group-pos_") >= 0 &&
        varValue.indexOf("_x_") >= 0
      ) {
        this.currentSelection.posX = parseFloat(
          splitValue[splitValue.length - 1]
        ).toFixed(2);
      } else if (
        varValue.indexOf("group-pos_") >= 0 &&
        varValue.indexOf("_y_") >= 0
      ) {
        this.currentSelection.posY = (
          parseFloat(splitValue[splitValue.length - 1]) * -1
        ).toFixed(2);
      } else if (
        varValue.indexOf("stone-pos_") >= 0 &&
        varValue.indexOf("_x_") >= 0
      ) {
        this.currentSelection.stonePosX = parseFloat(
          splitValue[splitValue.length - 1]
        ).toFixed(2);
      } else if (
        varValue.indexOf("stone-pos_") >= 0 &&
        varValue.indexOf("_y_") >= 0
      ) {
        this.currentSelection.stonePosY = (
          parseFloat(splitValue[splitValue.length - 1]) * -1
        ).toFixed(2);
      } else if (varValue.indexOf("mirror-") >= 0) {
        let mirrorExists = false;
        let isMirrorX = varValue.indexOf("mirror-x_") >= 0;
        let isMirrorXSet = false;

        if (
          this.possibleItems.list["mirror"] &&
          this.possibleItems.list["mirror"][0]
        ) {
          if (
            (isMirrorX && this.possibleItems.list["mirror"][0].x != 0) ||
            (!isMirrorX && this.possibleItems.list["mirror"][0].y !== "")
          ) {
            mirrorExists = true;
          }

          isMirrorXSet = this.possibleItems.list["mirror"][0].x != 0;
        }

        if (
          (isMirrorX && varValue.substr(-1) === "0") ||
          (!isMirrorXSet && varValue.substr(-1) === "_")
        ) {
          this.currentSelection.number = this.currentSelection.number / 2;
        } else if (!mirrorExists && !isMirrorXSet) {
          this.currentSelection.number = this.currentSelection.number * 2;
        }
      }
    },
    getCurrentStoneGroup: function () {
      // From current selection
      let currentGroupId = null;
      let currentStoneId = null;

      setTimeout(() => {
        for (let groupId in this.itemData.description.stones.groups) {
          let groupData = this.itemData.description.stones.groups[groupId];

          if (
            this.itemData.description.stones.groups.length > 1 ||
            (this.itemData.description.stones.groups.length == 1 &&
              groupData.stones.length > 1)
          ) {
            for (let stoneId in groupData.stones) {
              let stoneData = groupData.stones[stoneId];
              let posData = groupData;
              let posStoneData = stoneData;

              if (currentGroupId == null && currentStoneId == null) {
                if (
                  (this.currentSelection.side === "left" &&
                    groupData.side === "left") ||
                  (this.currentSelection.side === "right" &&
                    groupData.side === "right") ||
                  (this.currentSelection.side === "inside" &&
                    groupData.side === "inside")
                ) {
                  currentGroupId = groupId;
                  currentStoneId = 0;
                } else if (this.currentSelection.side === "top") {
                  /*
                      if ((
                          this.groupId != groupId ||
                          this.stoneId != stoneId
                      )) {
                        console.log(
                            groupId  + '-' + stoneId,
                            [this.currentSelection.lastVarValueStonePos, this.varValueStonePos],
                            [this.currentSelection.posX, this.currentSelection.posY],
                            [posData.posX, posData.posY],
                            [this.currentSelection.stonePosX, this.currentSelection.stonePosY],
                            [posStoneData.posX, posStoneData.posY]
                        );
                      }
                      */
                  if (
                    (this.groupId != groupId || this.stoneId != stoneId) && // Stein außen
                    ((this.currentSelection.typeId == stoneData.typeId &&
                      (this.currentSelection.size == stoneData.sizeTotal ||
                        this.currentSelection.lastAction.indexOf("type_") >
                          -1) &&
                      (this.currentSelection.qualityId == stoneData.qualityId ||
                        this.currentSelection.lastAction.indexOf("type_") >
                          -1) &&
                      this.currentSelection.number ==
                        parseInt(stoneData.number) &&
                      (this.currentSelection.pool == stoneData.pool ||
                        this.currentSelection.lastAction.indexOf("type_") >
                          -1) &&
                      (this.currentSelection.allocation ==
                        stoneData.allocation ||
                        this.currentSelection.lastAction.indexOf("type_") >
                          -1) &&
                      this.currentSelection.distanceAbs ==
                        parseFloat(
                          stoneData.distance ? stoneData.distance.abs : 0
                        ) &&
                      this.currentSelection.arrangement ==
                        groupData.arrangement &&
                      (this.currentSelection.object == groupData.object ||
                        this.currentSelection.lastAction.indexOf("type_") >
                          -1) &&
                      ((this.currentSelection.posX == posData.posX &&
                        this.currentSelection.posY == posData.posY) ||
                        this.currentSelection.lastAction.indexOf("type_") >
                          -1) &&
                      this.currentSelection.libraryStoneId < 1 &&
                      this.currentSelection.matrixId < 1 &&
                      this.currentSelection.allocation != 5 &&
                      this.currentSelection.allocation != 6 &&
                      this.currentSelection.allocationLast != 5 &&
                      this.currentSelection.allocationLast != 6 &&
                      this.currentSelection.posX == posData.posX &&
                      this.currentSelection.posY == posData.posY &&
                      this.currentSelection.stonePosX == posStoneData.posX &&
                      this.currentSelection.stonePosY == posStoneData.posY) || // Stein außen - Halb -und Vollausgefasst
                      (this.currentSelection.typeId == stoneData.typeId &&
                        this.currentSelection.qualityId ==
                          stoneData.qualityId &&
                        this.currentSelection.pool == stoneData.pool &&
                        this.currentSelection.allocation ==
                          stoneData.allocation &&
                        this.currentSelection.arrangement ==
                          groupData.arrangement &&
                        this.currentSelection.object == groupData.object &&
                        this.currentSelection.posX == posData.posX &&
                        this.currentSelection.posY == posData.posY &&
                        this.currentSelection.libraryStoneId < 1 &&
                        this.currentSelection.matrixId < 1 &&
                        (this.currentSelection.allocation == 5 ||
                          this.currentSelection.allocation == 6 ||
                          this.currentSelection.allocationLast == 5 ||
                          this.currentSelection.allocationLast == 6)) || // Stein außen - Matrix-Anordnung
                      (this.currentSelection.matrixId > 0 &&
                        this.currentSelection.libraryStoneId < 1 &&
                        this.currentSelection.matrixId == stoneData.matrixId &&
                        this.currentSelection.typeId == stoneData.typeId &&
                        this.currentSelection.qualityId ==
                          stoneData.qualityId &&
                        this.currentSelection.pool == stoneData.pool &&
                        this.currentSelection.arrangement ==
                          groupData.arrangement &&
                        this.currentSelection.object == groupData.object &&
                        this.currentSelection.posX == posData.posX &&
                        this.currentSelection.posY == posData.posY) || // Stein außen - Library-Stone
                      (this.currentSelection.libraryStoneId > 0 &&
                        this.currentSelection.libraryStoneId ==
                          groupData.libraryStoneId &&
                        this.currentSelection.arrangement ==
                          groupData.arrangement &&
                        this.currentSelection.object == groupData.object &&
                        this.currentSelection.posX == posData.posX &&
                        this.currentSelection.posY == posData.posY) || // Stein außen - Pool Switch
                      (this.currentSelection.libraryStoneId < 1 &&
                        this.currentSelection.lastAction.indexOf("pool_") >
                          -1 &&
                        this.currentSelection.typeId == stoneData.typeId &&
                        this.currentSelection.allocation ==
                          stoneData.allocation &&
                        this.currentSelection.distanceAbs ==
                          parseFloat(
                            stoneData.distance ? stoneData.distance.abs : 0
                          ) &&
                        this.currentSelection.number ==
                          parseInt(stoneData.number) &&
                        (this.currentSelection.pool == stoneData.pool ||
                          (this.currentSelection.pool == 2 &&
                            stoneData.size >= 0.3)) &&
                        this.currentSelection.size == stoneData.sizeTotal &&
                        this.currentSelection.arrangement ==
                          groupData.arrangement &&
                        this.currentSelection.object == groupData.object &&
                        this.currentSelection.posX == posData.posX &&
                        this.currentSelection.posY == posData.posY))
                  ) {
                    currentGroupId = groupId;
                    currentStoneId = stoneId;
                  }
                }
              }
            }
          }
        }

        if (currentGroupId != null && currentStoneId != null) {
          if (
            this.groupId == currentGroupId &&
            this.itemData.description.stones.groups[currentGroupId] &&
            this.itemData.description.stones.groups[currentGroupId]
              .libraryStoneId > 0
          ) {
            // do nothing
          } else if (
            currentGroupId != this.groupId ||
            currentStoneId != this.stoneId
          ) {
            if (this.currentSelection.lastVarValueStonePos !== "") {
              this.varValueStonePos =
                this.currentSelection.lastVarValueStonePos;
            }
            this.$parent.$parent.configure(
              "stones/group/" + currentGroupId + "/" + currentStoneId
            );
            this.clearCurrentSelection();
          }
        }
      });
    },
  },
  computed: {
    menuList: function () {
      return MenuList.get(this.currentItem);
    },
    isStoneGroupWithMoreThanOneStone: function () {
      return (
        this.itemData.description.stones.groups[this.groupId] &&
        this.itemData.description.stones.groups[this.groupId].stones &&
        this.itemData.description.stones.groups[this.groupId].stones.length >
          1 &&
        !this.itemData.description.stones.groups[this.groupId].libraryStoneId
      );
    },
  },
  watch: {
    "possibleItems.list": function () {
      if (typeof this.possibleItems.list.pos !== "undefined") {
        this.pos.x = this.possibleItems.list.pos.x;
        this.pos.y = this.possibleItems.list.pos.y;
      }

      if (typeof this.possibleItems.list.stonePos !== "undefined") {
        this.stonePos.x = this.possibleItems.list.stonePos.x;
        this.stonePos.y = this.possibleItems.list.stonePos.y;
      }

      if (
        typeof this.possibleItems.list.allocations !== "undefined" &&
        this.possibleItems.list.allocations !== false
      ) {
        this.allocation.type = this.possibleItems.list.allocations[0];
        this.allocation.distance =
          this.possibleItems.list.allocationDistance[0];
      }

      if (
        typeof this.possibleItems.list.waves !== "undefined" &&
        this.possibleItems.list.waves !== false
      ) {
        this.waves.lineAngle = this.possibleItems.list.waves[0].lineAngle;
        this.waves.sinus.waves = this.possibleItems.list.waves[0].sinus.waves;
        this.waves.sinus.distance =
          this.possibleItems.list.waves[0].sinus.distance;

        this.waves.type = this.waves.sinus.waves == 0 ? "angle" : "sinus";
      }

      if (
        typeof this.possibleItems.list.packages !== "undefined" &&
        this.possibleItems.list.packages !== false
      ) {
        this.packages.number = this.possibleItems.list.packages[0].number;
        this.packages.distance = this.possibleItems.list.packages[0].distance;
      }

      if (typeof this.possibleItems.list.clamping === "object") {
        this.clamping = this.possibleItems.list.clamping[0];
        this.clamping.top_factor = this.clamping.top_factor ? 1 : 0;
        this.clamping.down_factor = this.clamping.down_factor ? 1 : 0;
      }

      if (
        typeof this.possibleItems.list.number !== "undefined" &&
        this.possibleItems.list.number !== false
      ) {
        this.number =
          typeof this.possibleItems.list.number[0] == "undefined"
            ? false
            : this.possibleItems.list.number[0];
      }

      if (
        typeof this.possibleItems.list.sizes !== "undefined" &&
        this.possibleItems.list.sizes !== false
      ) {
        for (let key in this.possibleItems.list.sizes) {
          if (this.possibleItems.list.sizes[key].match == true) {
            this.size = this.possibleItems.list.sizes[key].id;
          }
        }
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
#app {
  .menu-section {
    cursor: pointer;
  }

  .headline-stone-quality {
    margin-bottom: 0.5rem;
  }

  label {
    font-weight: normal;
    line-height: 2.2em;
  }

  .text-bold {
    font-weight: bold;
  }

  img.ring {
    display: block;
    width: 5em;
    height: 5em;
    border-radius: 5em;
    border: solid 0.1rem $brandDarkGrey;
    margin: auto;
    margin-bottom: 0.5em;
  }

  .input-group input,
  .input-group select {
    height: 2.5em;
  }

  .object-position-info {
    display: inline-block;
    margin-top: 0.5rem;
    font-size: 0.8em;

    @media (min-width: 375px) {
      font-size: 0.9em;
    }
  }

  ul {
    list-style: none;
    padding: 0;
    margin: 0;
    text-align: center;
    display: inline-block;

    li {
      list-style: none;
      padding: 0;
      margin: 0.75em;
      text-align: center;
      display: inline-block;
      width: 6em;
      vertical-align: top;
    }

    li.match {
      position: relative;

      img.thumb {
        border: solid 0.2rem $brandGold;
      }

      .close {
        font-size: 2rem;

        img {
          border: none !important;
        }
      }
    }
  }

  div.highlight {
    .icon-star {
      display: flex;
      align-items: center;
      padding-left: 0.5rem;
      margin-top: -0.4rem;
      color: $pink;
    }
  }

  .quality-line {
    line-height: 2em;
    padding: 0.5rem 0rem;
    cursor: pointer;
  }

  .quality-line.on {
    background-color: $lightGreyBg;
    font-weight: bold;
  }

  .quality-line:hover {
    background-color: $lightGreyBg;
  }

  .premium-selection {
    h6 {
      font-size: 1em;
    }

    ul {
      border-bottom: solid 0.1em $lightGreyBg;

      li {
        margin: 1rem 0rem;
        display: block;
        text-align: left;
        width: 100%;
      }
    }
  }

  .item-plan {
    max-width: 66rem;
    cursor: pointer;
  }

  .input-group.change-pool,
  .form-control.mirror-stone {
    margin-top: 1rem;
  }

  #inputTotalCarat {
    padding-left: 0.1em;
    padding-right: 0.3em;

    @media (min-width: 992px) and (max-width: 1199px) {
      padding-left: 1.5rem;
    }
  }

  .input-position-x,
  .input-position-y {
    @media (min-width: 992px) and (max-width: 1199px) {
      width: 15%;
    }
  }

  .btn-remove-diamond {
    color: #fff;
    font-weight: bold;
    margin-bottom: 2rem;
    background-color: $gray;
    border-color: $gray;

    &.lab-grown {
      background-color: $green-lab;
      border-color: $green-lab;
    }
  }

  .input-group {
    margin-bottom: 1rem;
  }

  select {
    height: 4rem;
  }
}
</style>
